import {createHistory, LocationProvider, Router} from '@reach/router'
import {Slot, StartlibsProvider} from '@startlibs/core';
import {ThemeProvider} from 'styled-components';
import React, {Suspense} from 'react';
import {Notifications} from './components/Notifications'
import {Notifications as StartlibNotifications} from '@startlibs/components'
import {PageLoadingSuspense} from './components/PageLoading';
import {ProviderErrorBoundary} from './pages/errors/ProviderError'
import StartlibsConfig from './UIConfig/StartlibsConfig'
import StyledTheme from './UIConfig/StyledTheme'
import {Worklist} from './pages/Worklist'
import {Uploader} from './uploader/Uploader'
import {UploaderPage} from './uploader/UploaderPage'
import { DicomRouterProvider } from './utils/DicomRouterContext';


const Identity = React.forwardRef(({children}, ref) => <React.Fragment>{children}
  <div ref={ref}/>
</React.Fragment>)

let history
try{
  window.parent.document;
  history = createHistory(window.parent)
}catch(e){
  history = createHistory(window)
}

export const App = () => {

  const [uploadPanelOn, setUploadPanelOn] = React.useState(false)

  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function(child) {
      if (child.parentNode !== this) {
        if (console) {
          // console.error('Cannot remove a child from a different parent', child, this);
        }
        return child;
      }
      return originalRemoveChild.apply(this, arguments);
    }
  
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          // console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
        }
        return newNode;
      }
      return originalInsertBefore.apply(this, arguments);
    }
  }

  return <StartlibsProvider value={StartlibsConfig}>
    <ThemeProvider theme={StyledTheme}>
      <LocationProvider history={history}>
      <DicomRouterProvider>
      <>
        <ProviderErrorBoundary>
          <PageLoadingSuspense>
            <Router component={Identity}>
              <Worklist default uploadPanelOn={uploadPanelOn} className="notranslate"/>
              <UploaderPage path="/dicomuploader.php"/>
              <UploaderPage path="/dicomuploader"/>
            </Router>
          </PageLoadingSuspense>
        </ProviderErrorBoundary>
        <Notifications/>
        <StartlibNotifications/>
        <Router component={Identity}>
          <Identity path="/mobile-app/*"/>
        </Router>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: 100}}>
          <Slot name="Popup"/>
        </div>
        <Suspense fallback={null}>
          <Router component={Identity}>
            <Uploader default setUploadPanelOn={setUploadPanelOn}/>
            <Identity path="/dicomuploader/"/>
            <Identity path="/dicomuploader.php"/>
          </Router>
        </Suspense>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200}}>
          <Slot name="Portal"/>
          <Slot name="Dialog"/>
          <Slot name="Confirm-Dialog"/>
          <Slot name="Notification"/>
          <Slot name="Notifications"/>
        </div>
        <div style={{zIndex:10000}}>
          <Slot name="Modal"/>
        </div>
      </>
      </DicomRouterProvider>
      </LocationProvider>
    </ThemeProvider>
  </StartlibsProvider>
}
/*

const ColdRedirect = cold(Redirect)

class EnsureLoggedIn extends React.Component {
  state = {}

  componentDidCatch(error) {
    if (error.invalidateCache) {
      callIfFunction(error.invalidateCache)
      this.setState({navigate: true})
    }
  }

  static getDerivedStateFromError(error) {
    return {hasError: true}
  }

  render() {
    return !this.state.hasError
           ? <LoggedIn {...this.props}/>
           : this.state.navigate
             ? <Redirect to="/access"/>
             : null
  }
}
*/
